module.exports = __webpack_public_path__ + "img/status.f0388c71.png";